<template>
  <div class="outer">
    <div class="row g-0 align-items-center mb-4">
      <div class="col-12 col-md">
        <h2 class="display-3 fw-normal mb-3 mb-md-0">車輌チェックシート</h2>
      </div>
      <!-- /.col -->
      <div class="col-12 col-md-7 col-lg-6 col-xl-5">
        <table class="table table-bordered">
          <tbody class="border-1 lh-md">
            <tr>
              <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
                担当者
              </td>
              <td class="align-middle px-lg-3">
                <select
                  id="checkManagerId"
                  name="checkManagerId"
                  class="form-select form-select-sm"
                  v-model="rentalContractEditForm.maintenancePersonId"
                  disabled
                >
                  <optgroup
                    v-for="(department, id) in usersForSinglePulldownByVue
                      .users[0]"
                    :label="department.departmentName"
                    :key="id"
                  >
                    <option
                      v-for="user in department.users"
                      :value="user.id"
                      :key="user.id"
                    >
                      {{ user.name }}
                    </option>
                  </optgroup>
                </select>
                <div class="invalid-feedback">
                  {{ errors.checkManagerId.message }}
                </div>
              </td>
            </tr>
            <tr>
              <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
                実施日
              </td>
              <td class="align-middle px-lg-3">
                <div class="col">
                  <input
                    type="date"
                    id="processedDate"
                    name="processedDate"
                    class="form-control form-control-sm"
                    v-model="rentalContractEditForm.maintenanceDate"
                    placeholder="カレンダーから選択"
                    readonly
                  />
                  <div class="invalid-feedback">
                    {{ errors.processedDate.message }}
                  </div>
                </div>
                <!-- /.col -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->

    <div class="row g-4 mb-4">
      <div class="col-12 col-lg">
        <h6 class="bg-line text-center py-1">日常点検項目</h6>
        <table class="table table-bordered mb-2">
          <thead class="border-1 lh-md">
            <tr>
              <th scope="col" class="text-center bg-g05 text-nowrap px-3 py-1">
                箇所
              </th>
              <th scope="col" class="text-center bg-g05 text-nowrap px-3 py-1">
                内容
              </th>
              <th
                scope="col"
                class="text-center bg-g05 text-nowrap px-3 py-1 w-10"
              >
                良否
              </th>
            </tr>
          </thead>
          <tbody class="border-1 lh-md">
            <tr>
              <td class="align-middle text-center px-lg-3" rowspan="3">
                ブレーキ
              </td>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="brakeRoom">
                  ブレーキの踏みしろが適当
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="brakeRoom"
                  name="brakeRoom"
                  class="form-check-input"
                  v-model="rentalContractEditForm.brakeRoom"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="brakeEffective">
                  ブレーキの効きが十分
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="brakeEffective"
                  name="brakeEffective"
                  class="form-check-input"
                  v-model="rentalContractEditForm.brakeEffective"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="brakeFluid">
                  ブレーキフルードの液量が適当
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="brakeFluid"
                  name="brakeFluid"
                  class="form-check-input"
                  v-model="rentalContractEditForm.brakeFluid"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle text-center px-lg-3" rowspan="3">
                タイヤ
              </td>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="tireAir">
                  タイヤの空気圧が適当
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="tireAir"
                  name="tireAir"
                  class="form-check-input"
                  v-model="rentalContractEditForm.tireAir"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="tireGrooveDepth">
                  タイヤの溝の深さが十分
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="tireGrooveDepth"
                  name="tireGrooveDepth"
                  class="form-check-input"
                  v-model="rentalContractEditForm.tireGrooveDepth"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="tire_no_damage">
                  亀裂および損傷がなく異常な摩耗なし
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="tire_no_damage"
                  name="tire_no_damage"
                  class="form-check-input"
                  v-model="rentalContractEditForm.tireNoDamage"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle text-center px-lg-3" rowspan="2">
                バッテリー
              </td>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="batteryFull">
                  液量が適当
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="batteryFull"
                  name="batteryFull"
                  class="form-check-input"
                  v-model="rentalContractEditForm.batteryFull"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="batteryElec">
                  電気系統の作動状況が良好
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="batteryElec"
                  name="batteryElec"
                  class="form-check-input"
                  v-model="rentalContractEditForm.batteryElec"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle text-center px-lg-3" rowspan="2">
                灯火装置、<br />方向指示器
              </td>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="lampsNoDefect">
                  点灯または点滅具合に不良なし
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="lampsNoDefect"
                  name="lampsNoDefect"
                  class="form-check-input"
                  v-model="rentalContractEditForm.lampsNoDefect"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="lampsNoDamage">
                  汚れ、損傷がない
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="lampsNoDamage"
                  name="lampsNoDamage"
                  class="form-check-input"
                  v-model="rentalContractEditForm.lampsNoDamage"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle text-center px-lg-3" rowspan="4">
                原動機
              </td>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="engineOil">
                  冷却水およびエンジンオイルの量が適当
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="engineOil"
                  name="engineOil"
                  class="form-check-input"
                  v-model="rentalContractEditForm.engineOil"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="engineFunbelt">
                  ファンベルトの張り具合が適当であり損傷なし
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="engineFunbelt"
                  name="engineFunbelt"
                  class="form-check-input"
                  v-model="rentalContractEditForm.engineFunbelt"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="engineNoDefect">
                  原動機のかかり具合に不良なく異常音がない
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="engineNoDefect"
                  name="engineNoDefect"
                  class="form-check-input"
                  v-model="rentalContractEditForm.engineNoDefect"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="speedControl">
                  低速および加速の状態が適当
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="speedControl"
                  name="speedControl"
                  class="form-check-input"
                  v-model="rentalContractEditForm.speedControl"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle text-center px-lg-3" rowspan="2">
                ウィンドウ・<br />ウォッシャー、<br />ワイパー
              </td>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="windowLiquid">
                  液量が適当で噴射状態に不良なし
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="windowLiquid"
                  name="windowLiquid"
                  class="form-check-input"
                  v-model="rentalContractEditForm.windowLiquid"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="windowWiper">
                  ワイパーの払拭状態に不良なし
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="windowWiper"
                  name="windowWiper"
                  class="form-check-input"
                  v-model="rentalContractEditForm.windowWiper"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle text-center px-lg-3" rowspan="4">
                装備品
              </td>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="equipEtc">
                  ETC
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="equipEtc"
                  name="equipEtc"
                  class="form-check-input"
                  v-model="rentalContractEditForm.equipEtc"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="driveRecorder">
                  ドライブレコーダー
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="driveRecorder"
                  name="driveRecorder"
                  class="form-check-input"
                  v-model="rentalContractEditForm.driveRecorder"
                />
              </td>
            </tr>
            <tr>
              <td class="align-middle px-lg-3">
                <label class="form-check-label d-block" for="equipNavi">
                  ナビ（CD/DVD/HDD）
                </label>
              </td>
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="equipNavi"
                  name="equipNavi"
                  class="form-check-input"
                  v-model="rentalContractEditForm.equipNavi"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row g-2">
          <div class="col-6">
            <h6 class="bg-line text-center py-1">備品など</h6>
            <table class="table table-bordered">
              <thead class="border-1 lh-md">
                <tr>
                  <th
                    scope="col"
                    class="text-center bg-g05 text-nowrap px-3 py-1"
                  >
                    内容
                  </th>
                  <th
                    scope="col"
                    class="text-center bg-g05 text-nowrap px-3 py-1 w-10"
                  >
                    良否
                  </th>
                </tr>
              </thead>
              <tbody class="border-1 lh-md">
                <tr>
                  <td class="align-middle px-lg-3">
                    <label class="form-check-label d-block" for="smokeBomb">
                      発煙筒
                    </label>
                  </td>
                  <td class="align-middle text-center">
                    <input
                      type="checkbox"
                      id="smokeBomb"
                      name="smokeBomb"
                      class="form-check-input"
                      v-model="rentalContractEditForm.smokeBomb"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="align-middle px-lg-3">
                    <label class="form-check-label d-block" for="tools">
                      工具・ジャッキ
                    </label>
                  </td>
                  <td class="align-middle text-center">
                    <input
                      type="checkbox"
                      id="tools"
                      name="tools"
                      class="form-check-input"
                      v-model="rentalContractEditForm.tools"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="align-middle px-lg-3">
                    <label class="form-check-label d-block" for="spareTire">
                      スペアタイヤ
                    </label>
                  </td>
                  <td class="align-middle text-center">
                    <input
                      type="checkbox"
                      id="spareTire"
                      name="spareTire"
                      class="form-check-input"
                      v-model="rentalContractEditForm.spareTire"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="align-middle px-lg-3">
                    <label class="form-check-label d-block" for="triangular">
                      三角表示板
                    </label>
                  </td>
                  <td class="align-middle text-center">
                    <input
                      type="checkbox"
                      id="triangular"
                      name="triangular"
                      class="form-check-input"
                      v-model="rentalContractEditForm.triangular"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="align-middle px-lg-3">
                    <label class="form-check-label d-block" for="repairKit">
                      修理キット
                    </label>
                  </td>
                  <td class="align-middle text-center">
                    <input
                      type="checkbox"
                      id="repairKit"
                      name="repairKit"
                      class="form-check-input"
                      v-model="rentalContractEditForm.repairKit"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="align-middle px-lg-3">
                    <label class="form-check-label d-block" for="winch">
                      ウインチ
                    </label>
                  </td>
                  <td class="align-middle text-center">
                    <input
                      type="checkbox"
                      id="winch"
                      name="winch"
                      class="form-check-input"
                      v-model="rentalContractEditForm.winch"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.col -->
          <div class="col-6">
            <h6 class="bg-line text-center py-1">洗車清掃</h6>
            <table class="table table-bordered mb-2">
              <thead class="border-1 lh-md">
                <tr>
                  <th
                    scope="col"
                    class="text-center bg-g05 text-nowrap px-3 py-1"
                  >
                    内容
                  </th>
                  <th
                    scope="col"
                    class="text-center bg-g05 text-nowrap px-3 py-1 w-10"
                  >
                    良否
                  </th>
                </tr>
              </thead>
              <tbody class="border-1 lh-md">
                <tr>
                  <td class="align-middle px-lg-3">
                    <label
                      class="form-check-label d-block"
                      for="carWashExterior"
                    >
                      外装
                    </label>
                  </td>
                  <td class="align-middle text-center">
                    <input
                      type="checkbox"
                      id="carWashExterior"
                      name="carWashExterior"
                      class="form-check-input"
                      v-model="rentalContractEditForm.carWashExterior"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="align-middle px-lg-3">
                    <label
                      class="form-check-label d-block"
                      for="carWashInterior"
                    >
                      内装
                    </label>
                  </td>
                  <td class="align-middle text-center">
                    <input
                      type="checkbox"
                      id="carWashInterior"
                      name="carWashInterior"
                      class="form-check-input"
                      v-model="rentalContractEditForm.carWashInterior"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <h6 class="bg-line text-center py-1">その他</h6>
            <table class="table table-bordered">
              <thead class="border-1 lh-md">
                <tr>
                  <th
                    scope="col"
                    class="text-center bg-g05 text-nowrap px-3 py-1"
                  >
                    内容
                  </th>
                  <th
                    scope="col"
                    class="text-center bg-g05 text-nowrap px-3 py-1 w-10"
                  >
                    良否
                  </th>
                </tr>
              </thead>
              <tbody class="border-1 lh-md">
                <tr>
                  <td class="align-middle px-lg-3">
                    <label class="form-check-label d-block" for="scratchCheck">
                      キズチェック
                    </label>
                  </td>
                  <td class="align-middle text-center">
                    <input
                      type="checkbox"
                      id="scratchCheck"
                      name="scratchCheck"
                      class="form-check-input"
                      v-model="rentalContractEditForm.scratchCheck"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="align-middle px-lg-3">
                    <label class="form-check-label d-block" for="presence">
                      立会い
                    </label>
                  </td>
                  <td class="align-middle text-center">
                    <input
                      type="checkbox"
                      id="presence"
                      name="presence"
                      class="form-check-input"
                      v-model="rentalContractEditForm.presence"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.col -->
      <div class="col-12 col-lg">
        <h6 class="bg-line text-center py-1">車輌外装チェック</h6>
        <div class="border p-4 mb-2">
          <div class="ph position-relative" @click="showExteriorCheckModal()">
            <div
              class="w-100"
              style="
                background-image: url(/images/check_01.png);
                background-size: 100% 100%;
                background-repeat: no-repeat;
              "
            >
              <div
                class="row d-flex flex-nowrap px-2"
                v-for="m in exteriorCheckRow"
                :key="m"
              >
                <div
                  v-for="n in exteriorCheckCol"
                  :key="n"
                  :id="'exterior_' + m + '_' + n"
                  :class="'exterior_' + m + '_' + n"
                  class="col d-flex align-items-center justify-content-center"
                  style="height: 40px; font-size: 200%"
                  :data-row="m"
                  :data-col="n"
                ></div>
              </div>
            </div>
          </div>
          <input
            v-model="rentalContractEditForm.exteriorCheck"
            type="hidden"
            id="exteriorCheck"
            name="exteriorCheck"
          />
        </div>
        <h6 class="bg-line text-center py-1">車輌内装チェック</h6>
        <div class="border p-4">
          <div class="ph" @click="showInteriorCheckModal()">
            <div
              class="w-100"
              style="
                background-image: url(/images/check_02.png);
                background-size: 100% 100%;
                background-repeat: no-repeat;
              "
            >
              <div
                class="row d-flex flex-nowrap px-2"
                v-for="m in interiorCheckRow"
                :key="m"
              >
                <div
                  v-for="n in interiorCheckCol"
                  :key="n"
                  :id="'interior_' + m + '_' + n"
                  :class="'interior_' + m + '_' + n"
                  class="col d-flex align-items-center justify-content-center"
                  style="height: 90px; font-size: 200%"
                  :data-row="m"
                  :data-col="n"
                ></div>
              </div>
            </div>
          </div>
          <input
            v-model="rentalContractEditForm.interiorCheck"
            type="hidden"
            id="interiorCheck"
            name="interiorCheck"
          />
        </div>
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->

    <div class="border p-3 mb-4">
      <label for="memo" class="form-label mb-1"> 備考 </label>
      <textarea
        id="memo"
        name="memo"
        class="form-control"
        v-model="rentalContractEditForm.memo"
        rows="3"
      ></textarea>
    </div>
    <!-- /.border -->

    <div class="border p-3 mb-4">
      <h4 class="h5 fw-normal mb-1">確認事項</h4>
      <p class="kome">
        ①私は暴力団、暴力団員等、暴力団関連企業・又はこれらの密接交際者ではありません。
      </p>
      <p class="kome">
        ②この度の取引に係る、関係者・借受人・運転者・使用者のいずれも、暴力団、暴力団員等、暴力団関連企業・又はこれらの密接交際者ではありません。
      </p>
      <p class="kome">
        ③後日、上記確認事項に相違する事が判明した場合は、貴社より催告を受けなくても一切の契約の解除に応じ、損害賠償の請求も致しません。また、貴社から賃貸されているレンタカー及び物品はすみやかに返済いたします。
      </p>
      <p class="kome">
        ④私は、貴社が必要と判断した場合、本記載事項について各県警察署への照会を承諾いたします。
      </p>
      <hr class="my-3" />
      <div class="row g-0 justify-content-center row-cols-auto">
        <div class="col">
          <div class="form-check">
            <input
              type="checkbox"
              id="isAgreement"
              name="isAgreement"
              class="form-check-input"
              v-model="rentalContractEditForm.isAgreement"
            />
            <label class="form-check-label" for="isAgreement">
              上記、確認事項について同意する
            </label>
            <div class="invalid-feedback">
              {{ errors.isAgreement.message }}
            </div>
          </div>
          <!-- /.form-check -->
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.border -->

    <div class="border p-3 p-md-4 px-md-5">
      <h4 class="h5 fw-normal text-md-center mb-2">
        私は貴社の定めた貸渡約款に基づき貴社の自動車を借受けます。
      </h4>
      <p class="mb-1">借受人署名</p>
      <div class="text-white text-center mb-2">
        <Sign />
        <input
          v-model="rentalContractEditForm.signaturePath"
          type="hidden"
          id="signaturePath"
          name="signaturePath"
        />
        <div class="invalid-feedback">
          {{ errors.signaturePath.message }}
        </div>
      </div>
      <!-- /.bg -->
      <div class="text-end mb-2" v-if="isShow.canvas">
        <button
          type="button"
          class="btn btn-secondary rounded-pill"
          @click="canvasClear()"
        >
          クリア
        </button>
      </div>
      <p class="text-end" v-if="rentalContractEditForm.registrationAt">
        {{ rentalContractEditForm.registrationAt }}
      </p>
    </div>
    <!-- /.border -->
  </div>
  <!-- /.outer -->

  <!-- Modal -->
  <ExteriorCheckModal />
  <InteriorCheckModal />
  <!-- ./Modal -->
</template>

<script lang="ts">
/* Import Modules */
import { defineComponent, ref } from "vue";
/* Import Components */
import Sign from "../../canvas/sign.vue";
import ExteriorCheckModal from "../carScratches/exteriorCheckModal.vue";
import InteriorCheckModal from "../carScratches/interiorCheckModal.vue";
/* Import Variables */
import {
  rentalContractEditForm,
  vueCanvasDrawingRef,
  usersForSinglePulldownByVue,
  isShow,
} from "../../../compositions/variables";
import { errors } from "../../../compositions/validation/validation";
import {
  exteriorCheckRow,
  exteriorCheckCol,
} from "../../../compositions/rentContract/carScratches/exterior";
import {
  interiorCheckRow,
  interiorCheckCol,
} from "../../../compositions/rentContract/carScratches/interior";

/* Import Functions */
import { canvasClear } from "../../../compositions/script/canvas";
import { showExteriorCheckModal } from "../../../compositions/rentContract/carScratches/exterior";
import { showInteriorCheckModal } from "../../../compositions/rentContract/carScratches/interior";
export default defineComponent({
  components: {
    Sign,
    ExteriorCheckModal,
    InteriorCheckModal,
  },
  setup() {
    vueCanvasDrawingRef.value = ref<any>(null);

    return {
      /* variables */
      errors,
      exteriorCheckCol,
      exteriorCheckRow,
      interiorCheckRow,
      interiorCheckCol,
      rentalContractEditForm,
      usersForSinglePulldownByVue,
      isShow,
      /* functions */
      canvasClear,
      showExteriorCheckModal,
      showInteriorCheckModal,
    };
  },
});
</script>
